$(document).ready(function() {
    $('#exampleModal').modal('show');
})